<button
  type="button"
  class="destinations__backdrop"
  [class.destinations__backdrop--visible]="open()"
  aria-label="Cerrar"
  tabindex="-1"
  (click)="onClose()"
></button>

@if (open()) {
  <section
    #dialog
    class="destinations"
    role="dialog"
    aria-modal="true"
    aria-labelledby="destinations-title"
    tabindex="-1"
  >
    <header class="destinations__header">
      @if (mascotSrc()) {
        <img
          class="destinations__mascot"
          [src]="mascotSrc()"
          alt=""
          loading="lazy"
          [width]="mascotWidth()"
          [height]="mascotHeight()"
        />
      }
      <div class="destinations__heading">
        <h2 id="destinations-title" class="destinations__title">{{ title() }}</h2>
        @if (intro()) {
          <p class="destinations__intro">{{ intro() }}</p>
        }
      </div>
    </header>

    <ul class="destinations__list">
      @for (group of destinations; track group.province) {
        <li class="destinations__group">
          <div class="destinations__group-head">
            <span class="destinations__province">{{ group.province }}</span>
            <span class="destinations__price">{{ formatCRC(group.price) }}</span>
          </div>
          <p class="destinations__cantons">{{ group.cantons.join(' · ') }}</p>
        </li>
      }
    </ul>

    <div class="destinations__actions">
      <app-button variant="primary" size="md" type="button" (click)="onClose()">
        {{ ctaLabel() }}
      </app-button>
    </div>
  </section>
}
